import { render, staticRenderFns } from "./IconOss.vue?vue&type=template&id=c6f61e22"
import script from "./IconOss.vue?vue&type=script&lang=js"
export * from "./IconOss.vue?vue&type=script&lang=js"
import style0 from "./IconOss.vue?vue&type=style&index=0&id=c6f61e22&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports